import { FormControlError } from '../enums/FormControlError';

export const FormControlErrorDictionary = {
  [FormControlError.REQUIRED]: 'corporateTravellerProfile.errors.required',
  [FormControlError.MIN_LENGTH]: 'corporateTravellerProfile.errors.minLength',
  [FormControlError.MAX_LENGTH]: 'corporateTravellerProfile.errors.maxLength',
  [FormControlError.PATTERN]: 'corporateTravellerProfile.errors.pattern',
  [FormControlError.INCORRECT_PASSWORD]: 'auth.incorrectPassword',
  [FormControlError.PASSWORD_MISMATCH]: 'auth.passwordMismatch',
  [FormControlError.PASSWORD_SAME]: 'auth.passwordSame',
  [FormControlError.DATE_IN_THE_PAST]: 'corporateTravellerProfile.errors.pastDate',
  [FormControlError.DATE_IN_THE_FUTURE]: 'corporateTravellerProfile.errors.futureDate',
  [FormControlError.INVALID_AUTOCOMPLETE_STRING]: 'corporateTravellerProfile.errors.invalidAutoCompleteString',
  [FormControlError.INVALID_DATE_FORMAT]: 'corporateTravellerProfile.errors.invalidDateFormat',
  [FormControlError.ISSUE_DATE_TOO_LATE]: 'corporateTravellerProfile.errors.issueDateTooLate',
};
